/** @format */

import { ChangeDetectionStrategy, Component, input, inject, computed } from '@angular/core';

import { Breadcrumb } from '@shared/data-access/interfaces';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { NgClass } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectSEOBreadcrumbs } from '@plp/data-access/state';

@Component({
  selector: 'plp-components-breadcrumb',
  imports: [NgClass, HmfTextLinkComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlpBreadcrumbComponent {
  private readonly store = inject(Store);

  readonly searchTerm = input('');
  readonly isSearchPage = input(false);

  private readonly rawBreadcrumbs = this.store.selectSignal(selectSEOBreadcrumbs);
  readonly breadcrumbs = computed(() => this.rawBreadcrumbs() || []);

  /* This array will be used to set data-em attribute for each breadcrumb in incrementing length
   * ex. Breadcrumb_firstBreadcrumbName,
   * Breadcrumb_firstBreadcrumbName_secondBreadcrumbName,
   * Breadcrumb_firstBreadcrumbName_secondBreadcrumbName_thirdBreadcrumbName
   */
  readonly dataEm = computed(() => {
    let currentPath = '';

    return this.breadcrumbs().map((bc) => {
      const segment = bc.name.replaceAll(/\s+/g, '');
      currentPath = currentPath ? `${currentPath}_${segment}` : segment;
      return currentPath;
    });
  });

  protected trackByFn(index: number, item: Breadcrumb): string {
    return index.toString() + item.name;
  }
}
